import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const HandBagBold = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 14 14'
    fill='currentColor'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='m13.952 11.45-1.384-6.463A1.257 1.257 0 0 0 11.346 4h-.794l-.192-1.154a3.406 3.406 0 0 0-6.72 0L3.448 4h-.794a1.257 1.257 0 0 0-1.222.988l-1.384 6.46a2.059 2.059 0 0 0-.048.446A2.109 2.109 0 0 0 2.106 14h9.788A2.109 2.109 0 0 0 14 11.894a2.047 2.047 0 0 0-.048-.444ZM5.12 3.093a1.906 1.906 0 0 1 3.76 0L9.031 4H4.969Z' />
  </svg>
)

export { HandBagBold }
